<template>
<div >
  <div class="container ui-flex ui-flex-pack-center">
        	<div class="left-container ui-border-l" >
        		<div class="head-top" >
        			<img class="pointer" v-on:click="refurbish()" src="/static/img/icon13.png"  /> 
        			<div id="eqhengding" class="title" >{{eqObject.eqName}} </div>
        			<p class="subtitle" >{{eqObject.eqState==0?'离线':'在线'}}</p>
        		</div>
				   <div class="ui-flex ui-flex-pack-center mass-center">
				    <div v-on:mousedown="open("2")" v-on:mouseup="open("1")">
				    	<img  src="/static/img/qktanqi.png" id="buttonk" class="pointer" />	
				    	<p>全开</p>
				    </div>
				    <div v-on:mousedown="close("2")" v-on:mouseup="close("1")" class="left-padding">
				    	<img src="/static/img/qgtanqi.png" id="buttong" class="pointer" />	
				    	<p>全关</p>
				    </div>
				</div>
				<div class="mass-center-2 ui-flex ui-flex-ver ui-flex-align-start">
					<div v-for="obj in list1" style="width: 100%;" >
						<div class="column1" v-on:click="showName(obj)" ><img v-bind:src="[obj.citLinkState==0?'/static/img/icon14.png':'/static/img/icon15.png']" />{{obj.citName}}</div>
				    <div class="column2 ui-border-b" >
				    	<button class="button-type green" v-on:click="updateEq(obj,2,1)" >开</button>
				    	<button class="button-type red" v-on:click="updateEq(obj,2,0)" >关</button>
				    	<button class="button-type" v-on:click="updateEq(obj,2,2)" >点动</button> 
				    	<span class="time" >{{obj.citDdTime}}秒</span> 
				    	<button class="button-type" v-on:click="showTime(obj)" >设置</button> 
				    </div>
					</div>
				</div>
				<ul class="shuru-list ui-list ui-list-function ui-border-tb">
				    <li class="ui-border-t" v-for="obj in list2" >
				        <div class="ui-list-info">
				        	<img v-bind:src="[obj.citLinkState==0?'/static/img/icon14.png':'/static/img/icon15.png']" style="vertical-align: middle;" />
				            <span class="ui-nowrap">{{obj.citName}}</span>
				        </div>
				    </li>
				</ul>	
        	</div>
        </div>


<div class="right-container bluegack" style="position: relative;">
				<div class="search" results="s">
					<input class="" id="search" @keyup="updateEqList()" />
					<i class="ui-icon-search white"></i>
				</div>
				<div style="text-align:center;color:#000000"><span v-on:click="getEqListPage(pageSize-1)">< 上一页</span><span>&nbsp&nbsp&nbsp&nbsp{{pageSize+"/"+page}}&nbsp&nbsp&nbsp&nbsp</span><span v-on:click="getEqListPage(pageSize+1)">下一页 ></span>
					<ul class="shuru-list-right ui-list ui-list-function">

						<li @contextmenu.prevent="showMenu(eq,$event)" v-show="eq.eqType == 1 || eq.eqType == 2 || eq.eqType == 3 || eq.eqType == 4 || eq.eqType == 5 || eq.eqType == 6 || eq.eqType == 7 || eq.eqType == 8 || eq.eqType == 9 || eq.eqType == 10 || eq.eqType == 11 || eq.eqType == 12" v-bind:id="[eq.eqId]" class="border-bule-b pointer" v-for="(eq,index) in eqList" v-bind:class="[eq.eqId==eqId?'list-active':'']" v-on:click="clickEq(eq)">
							<div class="ui-row-flex">
								<div class="ui-col tc">
									<img v-if="eq.eqType == 1" v-bind:src="[eq.eqState==0?'/static/img/icon30.png':'/static/img/icon31.png']" />
									<img v-if="eq.eqType == 2" v-bind:src="[eq.eqState==0?'/static/img/icon17.png':'/static/img/icon16.png']" />
									<img v-if="eq.eqType == 3" v-bind:src="[eq.eqState==0?'/static/img/icon40.png':'/static/img/icon41.png']" />
									<img v-if="eq.eqType == 4" v-bind:src="[eq.eqState==0?'/static/img/peidiangui_hong.png':'/static/img/peidiangui_lv.png']" />
									<img v-if="eq.eqType == 5" v-bind:src="[eq.eqState==0?'/static/img/dingwei_hong.png':'/static/img/dingwei_lv.png']" />
									<img v-if="eq.eqType == 6" v-bind:src="[eq.eqState==0?'/static/img/danludingweihong.png':'/static/img/danludingweilv.png']" />
									<img v-if="eq.eqType == 7" v-bind:src="[eq.eqState==0?'/static/img/zhenfanzhuanhong.png':'/static/img/zhenfanzhuanlv.png']" />
									<img v-if="eq.eqType == 8" v-bind:src="[eq.eqState==0?'/static/img/baludingshilv.png':'/static/img/baludingshihong.png']" />
									<img v-if="eq.eqType == 9" v-bind:src="[eq.eqState==0?'/static/img/erludingshihong.png':'/static/img/erludingshilv.png']" />
									<img v-if="eq.eqType == 10" v-bind:src="[eq.eqState==0?'/static/img/siludingshihong.png':'/static/img/siludingshilv.png']" />
									<img v-if="eq.eqType == 11" v-bind:src="[eq.eqState==0?'/static/img/siludingweihong.png':'/static/img/siludingweilv.png']" />
                              
								</div>
								<div class="ui-col ui-col-2 ui-row-flex ui-row-flex-ver">
									<div class="ui-col text1">{{eq.eqName}}</div>
									<div class="ui-col text2"><img style="vertical-align: middle;" v-bind:src="[eq.eqDdjy==0?'/static/img/icon20.png':'/static/img/icon21.png']" /> 断电带记忆</div>
									<div class="ui-col text2">ID:{{eq.eqId}}</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="alert1 right-click" v-show="alert5" v-if="parent == '1'">
					<div class="dialog right-click-dialog" style="margin:0px;width:200px;padding:15px 15px; background: gainsboro;">
						<ul>
							<li v-on:click="showEq()">修改设备名称</li>
							<li v-on:click="removeEq()">删除此设备</li>
							<li v-on:click="showEqDdjy()">掉电记忆设置</li>
							<li v-on:click="jiaozhengshijian()" v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10">矫正时间</li>
							<li v-on:click="ht()">数据设备测试</li>
							
							<router-link :to="{ name:'ditu', params: {eqId:leftEq.eqId } }">
								<li v-if="leftEq.eqType ==5 || leftEq.eqType ==6 || leftEq.eqType ==11">显示位置</li>
							</router-link>
							<router-link :to="{ name:'shuju', params: {eqId:leftEq.eqId } }">
								<li v-if="leftEq.eqType ==12 ">数据设备</li>
							</router-link>
							
							
							<router-link :to="{ name:'dingshi', params: {eqId:leftEq.eqId,eqType:leftEq.eqType} }">
								<li v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10">定时设置</li>
							</router-link>
							<router-link :to="{ name:'port', params: {eqId:leftEq.eqId,eqType:leftEq.eqType } }">
								<li v-if="leftEq.eqType !=3 || leftEq.eqType !=6">端口报警提示设置</li>
							</router-link>
							<router-link :to="{ name:'port1', params: {eqId:leftEq.eqId } }">
								<li>停电来电报警设置</li>
							</router-link>
							<!--<router-link :to="{ name:'baojing', params: {eqId:leftEq.eqId } }">
								<li>报警记录导出</li>
							</router-link>-->
						</ul>
					</div>
				</div>

			</div>
			<!--<div class="alert right-click"  v-show="alert5" v-if="parent == '1'" >
				<div class="dialog right-click-dialog" >
					<ul>
						<li v-on:click="showEq()" >修改设备名称</li>
						
						<li v-on:click="showEqDdjy()" >掉电记忆设置</li>
						<router-link :to="{ name:'ditu', params: {eqId:leftEq.eqId } }"> <li v-if="leftEq.eqType ==5 || leftEq.eqType ==6" >显示位置</li></router-link>
				   	<router-link :to="{ name:'dingshi', params: {eqId:leftEq.eqId,eqType:leftEq.eqType} }"> <li v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10" >定时设置</li></router-link>
						<router-link :to="{ name:'port', params: {eqId:leftEq.eqId,eqType:leftEq.eqType } }"> <li v-if="leftEq.eqType !=3 || leftEq.eqType !=6" >端口报警提示设置</li></router-link>
						<router-link :to="{ name:'port1', params: {eqId:leftEq.eqId } }"> <li>停电来电报警设置</li></router-link>
					</ul>
				</div>
		</div>-->










		<div class="alert" v-show="alert1" >
    	<div class="dialog" >
    		<div><input class="input-type"  v-model="citName" placeholder="电路名称"  /> </div>
    		<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setName()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(1)" >取消</button></div>
    	</div>
	</div>
		<div class="alert" v-show="alert6" >
				<div class="dialog" >
					<div><input class="input-type"  v-model="alertEqName" placeholder="设备名称"  /> </div>
					<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setEqName()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(6)" >取消</button></div>
				</div>
		</div>
	<div class="alert" v-show="alert2" >
    	<div class="dialog" style="padding: 0;" >
    		<div class="ui-form ">
			        <div class="ui-form-item ui-form-item-switch">
			            <div style="color: #F9A81B;padding-left: 20px;" >
		              		 断电记忆
			            </div>
			            <label class="ui-switch">
			                <input type="checkbox" v-model="eqDdjy" >
			            </label>
			        </div>
			        <div class="ui-form-item ui-border-t" style="text-align: center;">
			        	<div  style="float: left;width: 49%;color: #3FB5FF;border-right:1px solid #e0e0e0;" class="pointer" v-on:click="setEqDdjy()" >确定</div>
			        	<div style="float: right;width: 50%;color: #3FB5FF;" class="btn-close pointer" v-on:click="closeShow(2)">取消</div>
		        	</div>
			</div>
    	</div>
	</div>
	<div class="alert" v-show="alert3" >
    	<div class="dialog" >
    		<div style="text-align:center;color:red;" >{{msg}} </div>
    	</div>
	</div>
	<div class="alert" v-show="alert4" >
    	<div class="dialog" >
    		<div><input id="citDdTime" v-model="citDdTime" class="input-type" placeholder="电动时间" /> </div>
    		<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setTime()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(4)" >取消</button></div>
    	</div>
	</div>
</div>
</template>
<script>
	 
       	
	

export default {
  name: 'devicemanage',
  data () {
    return {
      eqList:[],
			eqId:"",
			eqName:"",
			eqObject:this.$store.state.eqObject,
			list1:this.$store.state.list1,
			list2:this.$store.state.list2,
			eqType:"",
			alert1:false,
			alert2:false,
			alert3:false,
			alert4:false,
			alert5:false,
			alert6:false,
			msg:"",
			citObj:{},
			citDdTime:"",
			citName:"",
			leftEq:{},
			alertEqName:"",
			eqDdjy:false,
			parent:"1"
    }
           },

  
  
	methods:{
		setEqDdjy:function(){
			this.alert2 = false;
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1017",
				"uId":uid,
				eqId:this.leftEq.eqId,
				ddjyFlag:this.eqDdjy
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
						this.$http.post('/ZYun/HttpService.do', {
							"serviceCode":"1012",
							"uId":uid
						})
							.then((response) => {
								if(response.data.respCode=="0000"){
									this.eqList = response.data.eqList;
									this.eqId = this.eqList[0].eqId;
									this.clickEq(this.eqList[0]);
								}else{
									console.log(response);
								}
							})
							.catch((response) =>{
								console.log(response);
							});
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		showEqDdjy:function(){
			this.alert2 = true;
			if(this.leftEq.eqDdjy == "0"){
				this.eqDdjy = false;
			}
			if(this.leftEq.eqDdjy == "1"){
				this.eqDdjy = true;
			}
	},
		setEqName:function(){
			this.alert6 = false;
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1017",
				"uId":uid,
				eqId:this.leftEq.eqId,
				eqName:this.alertEqName
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
						this.$http.post('/ZYun/HttpService.do', {
							"serviceCode":"1012",
							"uId":uid
						})
							.then((response) => {
								if(response.data.respCode=="0000"){
									this.eqList = response.data.eqList;
									this.eqId = this.eqList[0].eqId;
									this.clickEq(this.eqList[0]);
								}else{
									console.log(response);
								}
							})
							.catch((response) =>{
								console.log(response);
							});
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		showEq:function(){
			this.alertEqName = "";
			this.alert6 = true;
		},
		removeEq:function(){
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1010",
				"uId":uid,
				eqId:this.leftEq.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		closeMenu:function(){
			this.alert5 = this.$store.state.alert5;
		},
		showMenu:function(obj,event){
			this.leftEq = obj;
			this.alert5 = true;
			console.log("右击了")
			this.$store.state.alert5 = true;
			$(".right-click").offset({top:event.screenY-150,left:event.screenX})
		},
		setName:function(){
			this.alert1 = false;
			this.updateEq(this.citObj,1,this.citName);
			this.citName = "";
	},
		showName:function(obj){
			this.citObj = obj;
			this.alert1 = true;
		},
		refurbish:function(){
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1021",
				"uId":uid,
				eqId:this.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						this.eqObject = response.data;
						this.eqType = response.data.eqType;
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							if(word1 == "0"){
								this.list1[i] = cit;
							}else{
								this.list2[i] = cit;
							}
						}
					}else{
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		closeShow(obj){
			if(obj == "1"){
				this.alert1 = false;
			}
			if(obj == "2"){
				this.alert2 = false;
			}
			if(obj == "3"){
				this.alert3 = false;
			}
			if(obj == "4"){
				this.alert4 = false;
			}
			if(obj == "5"){
				this.alert5 = false;
			}
			if(obj == "6"){
				this.alert6 = false;
			}
		},
		setTime:function(){
			var self = this;
			var re = /^[1-9]+[0-9]*]*$/;
			if (!re.test(this.citDdTime)) {
				this.alert4 = false;
				self.msg = "请输入数字";
				self.alert3 = true;
					window.setTimeout(function(){
					self.alert3 = false;
				},1000);
　　　　return ;
　　	}
			this.citObj.citDdTime = this.citDdTime;
			this.alert4 = false;
		},
		showTime:function(obj){
			this.citDdTime = "";
			this.alert4 = true;
			this.citObj = obj;
		},
		pad:function(num, n) {  
    var len = num.toString().length;  
    while(len < n) {  
        num = "0" + num;  
        len++;  
    }  
    return num;  
		},
		clickEq(eq){
			$("#"+eq.eqId).addClass("list-active");
			this.eqId = eq.eqId;
			this.eqName = eq.eqName;
			 
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			var eqId = history.setItem("eqId",this.eqId);
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1018",
				"uId":uid,
				eqId:this.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						this.eqObject = response.data;
						this.eqType = response.data.eqType;
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							if(word1 == "0"){
								this.list1[i] = cit;
							}else{
								this.list2[i] = cit;
							}
						}
					}else{
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		open:function(t){
		 if(t == "1"){
			 	$("#buttonk").attr("src", "/static/img/qktanqi.png");
		   var self = this;
		   this.eqObject.eqName = this.eqName;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1020",
				"uId":uid,
				eqId:this.eqId,
				citState:"1"
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "设备全开成功";
						self.alert3 = true;
						 window.setTimeout(function(){
						self.alert3 = false;
						self.clickEq(self.eqObject);
						},2000);
					
					}else{
						self.msg = "设备全开失败";
						self.alert3 = true;
						 window.setTimeout(function(){
						self.alert3 = false;
						self.clickEq(self.eqObject);
						},2000);
						console.log(response);
					}
				
				})
				.catch((response) =>{
					console.log(response);
				})
			
				
				 }else{
				 	$("#buttonk").attr("src", "/static/img/quankailv.png");
				 }
				 	$("#eqhengding").text(this.eqName)
		},
		close:function(t){
			if(t=="1"){
				$("#buttong").attr("src", "/static/img/qgtanqi.png");
				
				
			
			
			var self = this;
			this.eqObject.eqName = this.eqName;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1020",
				"uId":uid,
				eqId:this.eqId,
				citState:"0"
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "设备全关成功";
						self.alert3 = true;
						 window.setTimeout(function(){
						self.alert3 = false;
						self.clickEq(self.eqObject);
						},2000);
						
					}else{
						self.msg = "设备全关失败";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
              self.clickEq(self.eqObject);
            },2000);
						console.log(response);
					}
					
				})
				.catch((response) =>{
					console.log(response);
				})
					
				}else{
					$("#buttong").attr("src", "/static/img/quankaihong.png");
					
				}
				
		},
		updateEq:function(obj,type,value){
			var self = this;
			this.eqObject.eqName = this.eqName;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			var data = {};
			if(value == 1){
				data = {
					"serviceCode":"1019",
					"uId":uid,
					eqId:this.eqId,
					citId:obj.citId,
					citState:"1"
				}
			}
			console.log(obj.citDdTime)
			if(value == 2){
				data = {
					"serviceCode":"1019",
					"uId":uid,
					eqId:this.eqId,
					citId:obj.citId,
					citState:"2",
					citDdTime:obj.citDdTime
				}
			}
			if(value == 0){
				data = {
					"serviceCode":"1019",
					"uId":uid,
					eqId:this.eqId,
					citId:obj.citId,
					citState:"0"
	         }
			}
			
			
			
//			if(type == 1){
//				data = {
//					"serviceCode":"1019",
//					"uId":uid,
//					eqId:this.eqId,
//					citId:obj.citId,
//					citName:value
//				}
//			}
//			console.log(obj.citDdTime)
//			if(type == 2){
//				data = {
//					"serviceCode":"1019",
//					"uId":uid,
//					eqId:this.eqId,
//					citId:obj.citId,
//					citState:value,
//					citDdTime:obj.citDdTime
//				}
//			}
			this.$http.post('/ZYun/HttpService.do', data)
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
              self.clickEq(self.eqObject);
            },2000);
						
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },2000);
						console.log(response);
						self.clickEq(self.eqObject);
					}
					
				})
				.catch((response) =>{
					console.log(response);
				});
					$("#eqhengding").text(this.eqName)
		}
	},
	mounted: function () {
		this.list1 = this.$store.state.list1;
		this.list2 = this.$store.state.list2;
		this.eqObject = this.$store.state.eqObject;
		console.log(this.$store.state.list1);
		console.log(this.$store.state.list2);
		console.log(this.$store.state.eqObject);
	},
  components: {
  	 
  }
}
</script>

 Add "scoped" attribute to limit CSS to this component only 
<style scoped src="../../../static/css/mass.css">
.list-active{
	background-color: #0101FE;
}
</style>-->



// WEBPACK FOOTER //
// src/components/devicemanage/devicemanage1.vue